import _ from 'lodash';
import moment from 'moment';
export const leagueMatches = data => {
    const { matchdays, tournament, season } = data;
    const stage = season.stages[0];

    return [
        ...matchdays.map(date => ({
            id: 'TodayMatchesSMWidget',

            props: {
                tournamentId: tournament.id,
                date: date,
            },
            spec: {
                social: true,
                widgetGroup: 'TodayMatchesSMWidget',
            },
            category: ['Matches'],
            key: `${date + '_' + tournament.id}`,
        })),
        {
            id: 'RoundMatchesSMWidget',
            props: {
                tournamentId: tournament.id,
                seasonId: season.id,
                stageId: stage.id,
                full: true,
            },
            spec: {
                social: true,
                widgetGroup: 'RoundMatchesSMWidget',
            },
            category: ['Matches'],
            key: `tt-${season.id}-${stage.id}`,
        },
    ];
};

export const leagueTable = data => {
    const { tournament, season } = data;
    const stage = season.stages[0];
    return [
        {
            id: 'TournamentTableSMWidget',
            props: {
                tournamentId: tournament.id,
                seasonId: season.id,
                stageId: stage.id,
                full: true,
            },
            spec: {
                social: true,
                widgetGroup: 'TournamentTableSMWidget',
            },
            category: ['Table'],
            key: `tt-${season.id}-${stage.id}-table`,
        },
        {
            id: 'LeagueTrackerSMWidget',
            props: {
                tournamentId: tournament.id,
                seasonId: season.id,
                stageId: stage.id,
                full: true,
            },
            spec: {
                social: true,
                widgetGroup: 'LeagueTrackerSMWidget',
            },
            category: ['Table'],
            key: `tt-${season.id}-${stage.id}`,
        },
    ];
};

export const leagueTopLists = data => {
    const { tournament, season } = data;
    const stage = season.stages[0];

    return ['stats.goals', 'stats.assists', 'stats.cleansheets'].map(stat => ({
        id: 'TopListSMWidget',
        props: {
            tournamentId: tournament.id,
            seasonId: season.id,
            sortBy: stat,
        },
        spec: {
            social: true,
            widgetGroup: stat,
        },
        category: ['TopLists'],
        key: `tt-${season.id}-${stage.id}-${stat}`,
    }));
};

export const announments = data => {
    const { nextMatches } = data;

    return nextMatches.map(event => ({
        id: 'MatchAnnouncement',
        props: {
            eventId: event.eventId,
        },
        spec: {
            social: true,
            widgetGroup: event.eventId,
        },
        category: ['Upcoming Matches'],
        key: `an-${event.eventId}`,
    }));
};

export const preparWidgets = data => {
    const { tournament } = data;
    // const tournament = 46;
    // if (tournament.id == 46) return prepareLeagueOPTAWidgets(data);

    // // if champions league and europa league
    if (tournament.id == 42) return prepareCLEL(data);

    // // if cup
    // if (tournament.type == 'cup') return prepareCupWidget(data);

    // if standard league
    // if (tournament.type == 'league')
    return prepareLeagueWidgets(data);
};

export const prepareLeagueOPTAWidgets = () => {
    return [];
};

export const prepareCLEL = data => {
    const { matchdays, tournament, season } = data;

    return [
        ..._.filter(season.stages, s => !s.isCup).map(stage => ({
            id: 'TournamentTableSMWidget',
            props: {
                tournamentId: tournament.id,
                seasonId: season.id,
                stageId: stage.id,
                full: true,
            },
            spec: {
                social: true,
                widgetGroup: 'TournamentTableSMWidget' + stage.id,
            },
            category: ['Matches'],
            key: `tt-${season.id}-${stage.id}`,
        })),
    ];
};

export const prepareCup = () => {
    return [];
};

export const prepareLeagueWidgets = data => {
    return [
        // MATCHES
        ...leagueMatches(data),
        // TABLE
        ...leagueTable(data),
        // MATCH WIDGET? No... manybe advertisment
        ...leagueTopLists(data),
        // PLAYER COMPARE??? which player? - can be here
        ...announments(data),
        // LEAGUE-STREAKS - clear, best streaks in season

        // TRANSFERS - latest transfers, longest streaks
    ];
};

export const loadLeagueWidgets = (tournamentId, seasonId) => {
    return Promise.all([
        fetch(`https://ss2.si-ab.com/tournaments/${tournamentId}`).then(response => response.json()),
        fetch(`https://ss2.si-ab.com/tournaments/${tournamentId}/teams`).then(response => response.json()),
        fetch(`https://ss2.si-ab.com/tournaments/${tournamentId}/season`).then(response => response.json()),
        // next matches
        fetch(
            `https://ss2.si-ab.com/events-v2?ttId=${tournamentId}&status[]=live&status[]=notstarted&limit=10`,
        ).then(response => response.json()),
        fetch(
            `https://ss2.si-ab.com/events-v2?ttId=${tournamentId}&status=finished&limit=10&sortDirection=desc`,
        ).then(response => response.json()),
        // last matches
    ]).then(([tournament, teams, seasonData, nextMatches, lastMatches]) => {
        const data = {
            tournament,
            teams,
            season: seasonData.season,
            nextMatches: nextMatches.events,
            lastMatches: lastMatches.events,
            matchdays: _.chain(nextMatches.events)
                .groupBy(e => moment(e.startDate).format('YYYY-MM-DD'))
                .keys()
                .value(),
        };
        return { widgets: preparWidgets(data), data };
    });
};



/** WEBPACK FOOTER **
 ** ../src/dash/front/widget-picker/loaders/league.js
 **/